var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timebar",class:{ 'on_top': _vm.position === 'top', 'on_bottom': _vm.position === 'bottom' },style:({ 'width': ((Math.min(_vm.time / (_vm.totalTime * 10), 100)) + "%") })})}
var staticRenderFns = []

export { render, staticRenderFns }